import React /*, { useEffect }*/ from 'react';
//import Moment from 'moment';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import Day from './Day';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`event-tabpanel-${index}`}
      aria-labelledby={`event-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `event-tab-${index}`,
    'aria-controls': `event-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default (props) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // useEffect(() => {
  //   // set default tab on load
  //   for (let i = 0; i < props.config.days.length; i++) {
  //     const day = props.config.days[i];
  //     const startDate = Moment(day.startDate).valueOf();
  //     const endDate = Moment(day.endDate).valueOf();
  //     const now = new Date().getTime();
  //     if ((startDate <= now) && (now < endDate)) {
  //       setValue(i);
  //     }
  //   }
  // }, [props.config.days]);

  return (
    <div>
      <AppBar position="static" color="default"  className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          { props.config.days.map( (day, index) => (
            <Tab label={day.name} {...a11yProps(index)} key={index} />
          )) }
        </Tabs>
      </AppBar>
      { props.config.days.map( (day, index) => (
        <TabPanel value={value} index={index} key={index}>
          <Day config={day} setVideoSrc={props.setVideoSrc} />
        </TabPanel>
      )) }
    </div>
  );
}